import React from "react"
import { HandHeart, Moon, Sun } from "lucide-react"
import { Button } from "./ui/button"
import ProfileMenu from "./ui/ProfileMenu"
import AuthButton from "./ui/AuthButton"
import MyColoniesDropdown from "./MyColoniesDropdown"
import CryptoTicker from "./CryptoTicker"
import SheafButton from "./SheafButton"
import Breadcrumbs from "./Breadcrumbs"
import LanguageSelector from "./ui/LanguageSelector"
import { useAuth0 } from "@auth0/auth0-react"
import { useTranslation } from "../i18n"
import { connect } from "react-redux"
import { toggleDarkMode } from "../redux/actions/themeActions"
import { Link, useLocation } from "react-router-dom"
import { NotificationBell } from "./SignalR/NotificationBell"
import { FEATURE_FLAGS, isFeatureEnabled } from "../config/featureFlags"

function FeatureBar({ isDarkMode, toggleDarkMode }) {
  const { isAuthenticated } = useAuth0()
  const { t } = useTranslation()
  const location = useLocation()
  const bitcoinEnabled = isFeatureEnabled(FEATURE_FLAGS.bitcoinExperience)
  const sheafEnabled = isFeatureEnabled(FEATURE_FLAGS.sheafPurchase)

  const isPublicLandingPage = location.pathname === "/public"
  const isForumPage = location.pathname.startsWith("/forum")

  const handleToggle = () => {
    toggleDarkMode()
  }

  return (
    <div className="relative max-w-full overflow-x-hidden" id="feature-bar">
      <header className="bg-primary text-primary-foreground relative z-30 pt-0 pb-0 max-w-full overflow-x-hidden">
        <div className="container mx-auto max-w-full px-4">
          <div className="flex min-w-0 flex-wrap items-center justify-between gap-3">
            <div className="flex min-w-0 items-center gap-3">
              <div className="hidden md:flex items-center gap-4">
                <CryptoTicker cryptos={bitcoinEnabled ? ["bitcoin", "kinesis-silver", "pax-gold"] : ["kinesis-silver", "pax-gold"]} />
              </div>
              {isAuthenticated && sheafEnabled && <SheafButton />}
            </div>
            <div className="flex min-w-0 flex-1 flex-wrap items-center justify-end gap-3">
              <Link
                to="/needs"
                aria-current={location.pathname === "/needs" ? "page" : undefined}
                className="inline-flex min-h-[44px] items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold hover:bg-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                <HandHeart className="h-4 w-4" aria-hidden="true" />
                <span>Needs</span>
              </Link>
              {isAuthenticated && !isPublicLandingPage && !isForumPage && <MyColoniesDropdown />}
              {isAuthenticated && !isPublicLandingPage && <NotificationBell />}
              <Button
                variant="ghost"
                size="icon"
                onClick={handleToggle}
                className="hidden md:inline-flex"
              >
                {isDarkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
                <span className="sr-only">{t('layout.toggleDarkMode')}</span>
              </Button>
              <LanguageSelector />
              {!isPublicLandingPage && <ProfileMenu />}
              {isPublicLandingPage && <AuthButton />}
            </div>
          </div>
        </div>
      </header>
      <nav className="bg-secondary text-secondary-foreground shadow-md relative z-10 max-w-full overflow-x-hidden">
        <Breadcrumbs />
      </nav>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isDarkMode: state.theme.isDarkMode,
})

export default connect(mapStateToProps, { toggleDarkMode })(FeatureBar)
